const state = {
};

const getters = {
};

const actions = {
    getDomain({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('get_domain_info', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    getCreateDomainData({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('domains.create');
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    createDomain({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('domain_create_post');
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    updateDomain({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('domain_update', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.put(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    updateEnvDomain({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('domain_update_env', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    getEditDomainData({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('ajax_get_domain_edit', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    getEditEnvDomainData({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('domain_edit_env', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.get(r)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    setDomainStatus({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('ajax_domain_set_status', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    updateDomainAliases({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('domain_aliases_update');
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    resetPermissions({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('domain_reset_permissions', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },

    migrate({ commit }, request_data) {
        return new Promise((resolve, reject) => {
            let r = this._vm.$laroute.route('domain_migrate', {
                domain_id: request_data['domain_id'],
            });
            this._vm.$axios.post(r, request_data)
                .then(response => {
                    if(response.data.call_status === "OK")
                    {
                        resolve(response.data.data);
                    }
                    else
                    {
                        reject(response.data.error);
                    }
                })
                .catch(error => {
                    reject(error);
                })
                .finally(() => {

                });
        });
    },
};

const mutations = {
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
